export function scrollWindowByHeight(height) {
  window.scrollBy({
    top: height,
    behavior: "smooth", // Optional: Smooth scrolling effect
  });
}
export function scrollToBottom() {
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: "smooth", // Optional: Smooth scrolling effect
  });
}
